// 企業ロゴスライダー
let kvswiper;
const createkvswiper = () => {
  kvswiper = new Swiper(".js-p-top-kv-swiper", {
    loop: true,
    slidesPerView: 3.5,
    spaceBetween: 12,
    speed: 4500, // ループの時間
    allowTouchMove: false, // スワイプ無効
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      769: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1224: {
        speed: 6000,
        slidesPerView: 6.5,
        spaceBetween: 24,
      },
      // 1920: {
      //   slidesPerView: 6.5,
      //   spaceBetween: 24,
      // },
    },
  });
};

createkvswiper();